export default __webpack_public_path__ + "static/media/SourceSerif4-Regular.ff51b59e.otf";